import axios from 'axios';
import { API_URL } from './constants';



const axiosInstance = axios.create({
    baseURL: `${API_URL}`,
    headers: {
        'Content-Type': 'application/json',
    }
})

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `${token}`;
    }
    return config;
});



axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.message === "Network Error" && error.name === "AxiosError") {
            // Here you can trigger your error handling mechanism,
            // such as showing a notification, redirecting to an error page, etc.
            console.log("Network Error occurred:");
            // You might dispatch an action or trigger some other mechanism to handle the error
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;